var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Hidden_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 25719",
    transform: "translate(1956 281)",
    fill: "#8493bd",
    stroke: "#707070",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1956 -281)",
    clipPath: "url(#Hidden_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bold/Hide"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Hide",
    d: "M1962.259 298.847a.521.521 0 01-.062-.653l.02-.028 10.183-10.278a.175.175 0 00.034-.041.231.231 0 00.04-.047l.647-.653a.524.524 0 01.367-.147.511.511 0 01.363.151.51.51 0 01.154.368.509.509 0 01-.154.368l-1.251 1.265a10.43 10.43 0 012.48 3.641.54.54 0 010 .41c-1.476 3.464-4.1 5.531-7.019 5.531h-.01a6.417 6.417 0 01-3.726-1.234l-1.336 1.347a.514.514 0 01-.365.153.494.494 0 01-.365-.153zm4.25-3.547a2.747 2.747 0 004.298-2.3 2.816 2.816 0 00-.475-1.564l-.752.764a1.751 1.751 0 01.194.8 1.725 1.725 0 01-1.715 1.73 1.7 1.7 0 01-.8-.194zm-5.468-2.093a.527.527 0 010-.41c1.474-3.461 4.099-5.525 7.012-5.525h.007a6.248 6.248 0 012.824.681l-2.3 2.321a3.181 3.181 0 00-.523-.049 2.767 2.767 0 00-2.761 2.78 3.223 3.223 0 00.048.528l-2.548 2.567a11.176 11.176 0 01-1.759-2.893z"
  })))));
}
export default SvgHiddenIcon;